export default class ClarityService {
  private CLARITY_KEY = 'id38xztyhu'

  public initClarity(squidId: string) {
    const scripts = document.getElementsByTagName('script')
    for (let i = 0; i < scripts.length; i++) {
      if (
        scripts[i].type === 'text/javascript' &&
        scripts[i].innerHTML.includes('clarity') &&
        scripts[i].innerHTML.includes(this.CLARITY_KEY)
      ) {
        scripts[i].parentNode?.removeChild(scripts[i])
      }
      if (scripts[i].src.includes(this.CLARITY_KEY)) {
        if (squidId && !document.getElementById(`clarity-${this.CLARITY_KEY}`)) {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.setAttribute('id', `clarity-${this.CLARITY_KEY}`)
          script.innerHTML = `
            clarity("set", "userId", "${squidId}")
          `
          document.head.appendChild(script)
        }
      }
    }
  }
}
